import { render, staticRenderFns } from "./EditClassCategory.vue?vue&type=template&id=8a265ec0&scoped=true&"
import script from "./EditClassCategory.vue?vue&type=script&lang=js&"
export * from "./EditClassCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditClassCategory.vue?vue&type=style&index=0&id=8a265ec0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a265ec0",
  null
  
)

export default component.exports